// extracted by mini-css-extract-plugin
export var layoutContainer = "_9p-0";
export var layoutContainerNoRounding = "_9p-6";
export var layoutContainerOpen = "_9p-5";
export var layoutContainerResizing = "_9p-1";
export var mainContent = "_9p-2";
export var resizeDivider = "_9p-3";
export var slidePanel = "_9p-4";